var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrategyAndPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 9.5C4.75 6.87665 6.87665 4.75 9.5 4.75H22.5C25.1234 4.75 27.25 6.87665 27.25 9.5V22.5C27.25 25.1234 25.1234 27.25 22.5 27.25H9.5C6.87665 27.25 4.75 25.1234 4.75 22.5V9.5ZM9.5 6.25C7.70507 6.25 6.25 7.70507 6.25 9.5V22.5C6.25 24.2949 7.70507 25.75 9.5 25.75H22.5C24.2949 25.75 25.75 24.2949 25.75 22.5V9.5C25.75 7.70507 24.2949 6.25 22.5 6.25H9.5ZM21.5364 13.6881L17.8345 19.6253C17.2443 20.572 15.9307 20.7321 15.1304 19.9548L12.832 17.7228C12.7305 17.6243 12.5677 17.6295 12.4727 17.7342L9.70484 20.7844C9.42649 21.0912 8.95218 21.1142 8.64543 20.8359C8.33868 20.5575 8.31565 20.0832 8.594 19.7765L11.3618 16.7262C12.0269 15.9933 13.167 15.9572 13.877 16.6467L16.1754 18.8788C16.2897 18.9898 16.4774 18.9669 16.5617 18.8317L20.2875 12.856L17.1242 13.7239L16.7803 12.4702L21.6897 11.1233C21.8665 11.0748 22.0556 11.1032 22.2104 11.2015C22.3651 11.2998 22.4711 11.4589 22.5023 11.6396L23.3647 16.6396L22.0836 16.8606L21.5364 13.6881Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyAndPlanning);
export default __webpack_public_path__ + "static/media/strategy-and-planning.a06092c6d08d758b114a4f332e359db1.svg";
export { ForwardRef as ReactComponent };